"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@mui/material/styles");
var CardMedia_1 = __importDefault(require("@mui/material/CardMedia"));
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var userPermissions_1 = require("@/Hooks/userPermissions");
var CheckBoxAction = function (_a) {
    var onCheckBoxTick = _a.onCheckBoxTick;
    var selectedIds = (0, react_admin_1.useListContext)().selectedIds;
    (0, react_1.useEffect)(function () {
        onCheckBoxTick(selectedIds);
    }, [selectedIds]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var IntegrationNameField = function (_a) {
    var source = _a.source, label = _a.label;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    return (react_1.default.createElement("div", { style: { display: "flex", width: "100%" } },
        react_1.default.createElement(CardMedia_1.default, { component: "img", sx: { width: 17, height: 15, marginRight: "0.5em" }, image: record.icon, alt: "Integration Icon" }),
        react_1.default.createElement("span", { className: "ns-font-family", style: { color: "var(--info-color)" }, "data-cy": "integrationRecord" }, record[source])));
};
var AppIntegrationsListView = function (_a) {
    var onRowClick = _a.onRowClick, permissions = _a.permissions, resourceType = _a.resourceType;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var unselect = (0, react_admin_1.useUnselect)("app-integrations");
    var refresh = (0, react_admin_1.useRefresh)();
    var _b = (0, react_1.useState)(false), checkBoxIsActive = _b[0], setCheckBoxIsActive = _b[1];
    var _c = (0, react_1.useState)([]), bulkActionIntegrationIds = _c[0], setBulkActionIntegrationIds = _c[1];
    var _d = (0, react_1.useState)(null), currentIntegrationId = _d[0], setCurrentIntegrationId = _d[1];
    var _e = (0, react_1.useState)(false), confirmationModalOpened = _e[0], setConfirmationModalOpened = _e[1];
    var _f = (0, react_1.useState)(false), deleteMultipleConfirmationModalOpened = _f[0], setDeleteMultipleConfirmationModalOpened = _f[1];
    var logger = q_play_core_1.logManager.getLogger();
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var toggleConfirmationModal = function () {
        setConfirmationModalOpened(function (prevState) { return !prevState; });
    };
    var toggleDeleteMultipleConfirmationModal = function () {
        setDeleteMultipleConfirmationModalOpened(function (prevState) { return !prevState; });
    };
    var deleteSingleIntegration = function (currentIntegrationId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCurrentIntegrationId(currentIntegrationId);
                    if (!currentIntegrationId) {
                        logger.error("Current integration ID is null");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.deleteAppIntegrations([currentIntegrationId])];
                case 2:
                    _a.sent();
                    setConfirmationModalOpened(false);
                    unselect([currentIntegrationId]);
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Error in deleting integration:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmDelete = function () {
        if (currentIntegrationId) {
            deleteSingleIntegration(currentIntegrationId);
        }
        else {
            logger.error("No integration ID selected");
        }
    };
    var deleteMultipleIntegrations = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deleteAppIntegrations(bulkActionIntegrationIds)];
                case 1:
                    _a.sent();
                    setDeleteMultipleConfirmationModalOpened(false);
                    unselect(bulkActionIntegrationIds);
                    refresh();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error in deleting integrations:", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onCheckBoxTickHandler = function (selectedIds) {
        setCheckBoxIsActive(selectedIds.length > 0);
        setBulkActionIntegrationIds(selectedIds);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_admin_1.ListBase, { filter: { global: false } },
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: resourceType },
                react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["list-view-quick-actions-container"] },
                    react_1.default.createElement(q_play_components_1.Button, { text: t("Delete"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: AppIntegrations_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive, onClick: toggleDeleteMultipleConfirmationModal, dataCy: "deleteIntegrationButton" }))),
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                react_1.default.createElement(AccessControl_1.default, { resourceType: resourceType, conditionalChildren: [
                        {
                            permission: permissions.manage,
                            children: (react_1.default.createElement(react_admin_1.Datagrid, { hover: false, rowClick: function (id, basePath, record) {
                                    if (hasPermission(__spreadArray([], permissions.manage, true), record.id)) {
                                        onRowClick(record);
                                        return false;
                                    }
                                }, sx: RAStyles_1.RaAppIntegrationDataGridSx, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { onCheckBoxTick: onCheckBoxTickHandler }) },
                                react_1.default.createElement(IntegrationNameField, { source: "name", label: t("Name") }),
                                react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(AccessControl_1.default, { resourceId: record.id, resourceType: resourceType, optionalPermissions: __spreadArray(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), ["edit-user-management"], false) },
                                        react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () { return onRowClick(record); }, resourceId: record.id, type: "Resource", onDelete: function () {
                                                setCurrentIntegrationId(record.id);
                                                toggleConfirmationModal();
                                            }, resourceType: types_1.ResourceType.INTEGRATION }))); } })))
                        },
                        {
                            permission: __spreadArray(__spreadArray([], permissions.read, true), permissions.write, true),
                            children: (react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RAStyles_1.RaAppIntegrationDataGridSx, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { onCheckBoxTick: onCheckBoxTickHandler }) },
                                react_1.default.createElement(IntegrationNameField, { source: "name", label: t("Name") })))
                        }
                    ] })),
            react_1.default.createElement(Pagination_1.default, null)),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: confirmationModalOpened, onClose: toggleConfirmationModal, onConfirm: handleConfirmDelete, onCancel: toggleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true }),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: deleteMultipleConfirmationModalOpened, onClose: toggleDeleteMultipleConfirmationModal, onConfirm: deleteMultipleIntegrations, onCancel: toggleDeleteMultipleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true })));
};
exports.default = AppIntegrationsListView;
